/*
  Spectrum Variant Picker Bridge
  ──────────────────────────────
  Wires the Spectrum-Studio variant picker (snippet vdc8x4kp / element
  <sai-vdc8x4kp>) into Horizon's native <variant-picker> component so
  ATC submits the correct variant.

  Why this is needed:
    The Spectrum runtime fires a `variant:change` custom event AND
    tries to sync via Shopify's standard `[name="options[<Option>]"]`
    radio convention. Horizon doesn't use that convention — its radios
    are named `<OptionName>-<block-hash>-<product-id>` with a
    `data-variant-id="..."` attribute carrying the resolved id. So the
    Spectrum sync misses Horizon's radios entirely, ATC keeps the
    original variant, and clicking the Spectrum picker only updates
    the URL (which the gallery observes) but not the buy form.

  Fix:
    Listen for the Spectrum runtime's `variant:change` event, find the
    matching Horizon radio by `data-variant-id`, and click it. That
    routes through Horizon's own change handler (which updates the
    form's hidden variant id, price block, accelerated checkout
    button, and dispatches all the secondary updates the theme
    expects).

  Theme-side only — no canonical changes to the Spectrum runtime.
*/

(function () {
  if (window.__spectrumVariantBridgeInit) return;
  window.__spectrumVariantBridgeInit = true;

  document.addEventListener('variant:change', function (e) {
    var variantId = String((e && e.detail && e.detail.variantId) || '');
    if (!variantId) return;

    // Look for any Horizon radio with the matching data-variant-id that
    // isn't already checked. Scoped to <variant-picker> so we don't
    // accidentally click something else.
    var radio = document.querySelector(
      'variant-picker input[type="radio"][data-variant-id="' + variantId + '"]:not(:checked)'
    );
    if (!radio) return;

    radio.checked = true;
    // Mirror Horizon's own click flow so its internal currentChecked
    // bookkeeping stays consistent.
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
